import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "work",
  class: "pt-4 md:pt-6 pb-10 md:pb-12 bg-white"
}
const _hoisted_2 = { class: "container mx-auto px-4 md:px-6" }
const _hoisted_3 = { class: "overflow-x-auto mb-6 border-b" }
const _hoisted_4 = { class: "flex justify-start md:justify-start min-w-max md:min-w-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "text-2xl md:text-3xl font-bold mb-2 md:mb-3 text-safari-black" }
const _hoisted_9 = { class: "text-gray-700 mb-3 md:mb-4 text-sm md:text-base" }
const _hoisted_10 = { class: "rounded-lg overflow-hidden h-64 md:h-80 bg-black" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-3xl sm:text-4xl md:text-4xl font-bold text-center mb-2 md:mb-3 text-primary" }, "Our Work", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              onClick: ($event: any) => (_ctx.activeTab = index),
              class: _normalizeClass(['px-4 md:px-6 py-3 font-semibold transition-colors text-sm md:text-base whitespace-nowrap', _ctx.activeTab === index ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'])
            }, _toDisplayString(tab.title), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.tabs[_ctx.activeTab].title), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.tabs[_ctx.activeTab].description), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("iframe", {
            key: _ctx.tabs[_ctx.activeTab].video,
            src: _ctx.tabs[_ctx.activeTab].video,
            class: "w-full h-full",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: "",
            loading: "lazy"
          }, null, 8, _hoisted_11))
        ])
      ])
    ])
  ]))
}